import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

// Common function to show 'PRINT INVOICE' button in client portal BOLs.
export default () => {
    let Record = useContext(RecordsManagementContext);

    const estimateId =
        Record.IV1_PageDetails.pdf_est_id ||
        Record.IV2_PageDetails.pdf_est_id ||
        Record.IV3_PageDetails.pdf_est_id ||
        (Record.CP_PageDetails.ClientPortalHeader && Record.CP_PageDetails.ClientPortalHeader.PrintPortal && Record.CP_PageDetails.ClientPortalHeader.PrintPortal.estimate_id) ||
        '';

    const bolType =
        Record.IV1_PageDetails.bol_type ||
        Record.IV2_PageDetails.bol_type ||
        Record.IV3_PageDetails.bol_type ||
        '';

    const invoiceType = Record.CP_PageDetails.InvoiceType || '';

    const baseUrl =
        Record.IV1_PageDetails.url ||
        Record.IV2_PageDetails.url ||
        Record.IV3_PageDetails.url ||
        (Record.CP_PageDetails.ClientPortalHeader && Record.CP_PageDetails.ClientPortalHeader.PrintPortal && Record.CP_PageDetails.ClientPortalHeader.PrintPortal.url) ||
        '';

    const printInvoice = () => {
        if (!baseUrl || !estimateId) {
            return;
        }

        let endpoint = '/print_invoice_by_client';

        if (bolType === 'BOL, V2' || invoiceType === 'INVOICE_2') {
            endpoint = '/print_invoice_2';
        } else if (bolType === 'NC BOL' || invoiceType === 'INVOICE_3') {
            endpoint = '/print_invoice_3';
        } else if (bolType === 'Texas BOL') {
            endpoint = '/print_texas_bol_invoice';
        }

        const url = `${baseUrl}${endpoint}?id=${estimateId}`;
        window.open(url, '_blank');
    };

    return (
        <button className='btn btn-dark btn-sm m-lg-2' onClick={printInvoice}>
            <b>PRINT INVOICE</b>
        </button>
    );
};
